import React, {useState} from "react";
import {CustomerFluidSubPageLayout} from "../../layouts/customerLayout/customerFluidSubPageLayout/CustomerFluidSubPageLayout";
import {MerchantCashOnDeliveryPage} from "../../cashOnDelivery/merchant/MerchantCashOnDeliveryPage";
import {CustomerMenuHeader} from "components/layouts/customerLayout/components/customerMenuHeader";
import {useCodPaymentMethodSelection} from "hooks/useCodPaymentMethodSelection";
import {Empty} from "antd";
import {CodAggrementSelectionModal} from "components/cashOnDelivery/summary/filterButton/codAggrementBlock/CodAggrementSelectionModal";
import {CaretRightOutlined} from "@ant-design/icons";
import {CustomButton} from "components/_defaultComponents/CustomButton/CustomButton";
import {ContractDetails} from "components/layouts/customerLayout/components/customerAccountingDetailInfo/CustomerAccountingDetailInfo.styles";
import {EmptyWrapper, InfoItem} from "./style/CustomerCashOnDeliveryPage";

const CustomerCashOnDeliveryPage = ({isBackoffice = false}) => {
    const [recall, setRecall] = useState(false);
    const [open, setOpen] = useState(false);
    const {
        subCompaniesResults,
        subCompaniesResultsLoading,
        canCodPaymentMethodSelectionSubcompanies,
        canShowCodPaymentMethodSelection,
        alreadyHasCoDPaymentContractSubcompanies,
        generateCoDPaymentContract,
        getCoDPaymentContract,
        contractLoading
    } = useCodPaymentMethodSelection({
        initialCall: true,
        initialData: [],
        dependencies: [recall],
        isBackoffice: isBackoffice
    });

    return (
        <CustomerFluidSubPageLayout pageTitle="Kapıda Ödeme">
            <CustomerMenuHeader
                canShowCodPaymentMethodSelection={canShowCodPaymentMethodSelection}
            />
            {subCompaniesResultsLoading ? (
                <div style={{padding: "40px", textAlign: "center"}}>Yükleniyor...</div>
            ) : canShowCodPaymentMethodSelection ? (
                <EmptyWrapper>
                    <Empty
                        description={
                            <span>
                                Siparişlerinizde kapıda ödeme alabilmemiz için ilgili{" "}
                                <strong>sözleşmeyi</strong> onaylayınız.
                            </span>
                        }
                    />
                    <InfoItem>
                        <ContractDetails style={{marginLeft: "auto", marginTop: "auto"}}>
                            <CustomButton
                                onClick={() => setOpen(true)}
                                className="all-contracts-btn"
                                style={{marginRight: "0px"}}
                            >
                                Kapıda Ödeme Sözleşmesi Oluştur
                                <CaretRightOutlined />
                            </CustomButton>
                        </ContractDetails>
                    </InfoItem>
                </EmptyWrapper>
            ) : (
                <MerchantCashOnDeliveryPage />
            )}
            <CodAggrementSelectionModal
                open={open}
                setOpen={setOpen}
                recall={recall}
                setRecall={setRecall}
                canCodPaymentMethodSelectionSubcompanies={canCodPaymentMethodSelectionSubcompanies}
            />
        </CustomerFluidSubPageLayout>
    );
};

export default CustomerCashOnDeliveryPage;
